<img [src]="diaryIconPath" width="25"> {{label}}
